import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { fetchUrls } from '../services/savedItems'
import type { GetUrlsResponse, GetUrlsFilter } from '../types'
import { urlKeys } from './queryKeys'

interface UseUrlsOptions {
  enabled?: boolean
}

export function useUrls(
  filters: GetUrlsFilter = {},
  options: UseUrlsOptions = {},
): UseQueryResult<GetUrlsResponse> {
  return useQuery<GetUrlsResponse>({
    queryKey: urlKeys.list(filters),
    queryFn: () => fetchUrls(filters),
    staleTime: 30_000,
    enabled: options.enabled ?? true,
  })
}
